/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { Query } from '@apollo/client/react/components';
import {
    bool, func, shape, string,
} from 'prop-types';
import mbpLogger from '@module-logger/mbp';

import findContent from '../../../../../gql/queries/findContent';
import { GRAPHQL_ENV } from '../../../../../gql';
import TandCInformation from './TandCInformation';

const SubscriptionTnC = ({
    brand, copy, renderers, userConfirmation, handleModal, open,
}) => {
    const findContentOptions = {
        brand: brand.domain,
        contentType: 'brand_configuration',
    };
    const GET_SUBSCRIPTION_INFORMATION = findContent(findContentOptions);
    return (
        <Query query={GET_SUBSCRIPTION_INFORMATION}>
            {({ loading, error, data }) => {
                if (loading) {
                    return <div style={{ height: '82px' }} />;
                }
                if (error) {
                    mbpLogger.logError({
                        appName: process.env.npm_package_name,
                        query: GET_SUBSCRIPTION_INFORMATION,
                        component: ' SubscriptionInformation.js',
                        message: 'Error loading data from Graphql',
                        env: GRAPHQL_ENV,
                        error,
                    });
                    return null;
                }
                if (!data) {
                    mbpLogger.logWarning({
                        appName: process.env.npm_package_name,
                        query: GET_SUBSCRIPTION_INFORMATION,
                        component: ' SubscriptionInformation.js',
                        message: 'No data returned for query',
                        env: GRAPHQL_ENV,
                    });
                    return null;
                }
                if (!data?.findContent?.content?.entries) {
                    mbpLogger.logWarning({
                        appName: process.env.npm_package_name,
                        query: GET_SUBSCRIPTION_INFORMATION,
                        component: ' SubscriptionInformation.js',
                        message: 'No product returned for query',
                        env: GRAPHQL_ENV,
                    });
                    return null;
                }

                let subscriptionInformation = <></>;

                const subscriptionData = {
                    terms: data.findContent?.content?.entries?.[0]?.other.subscription_terms || null,
                };

                if (subscriptionData.terms) {
                    subscriptionInformation = (
                        <TandCInformation data={subscriptionData} copy={copy} renderers={renderers} userConfirmation={userConfirmation} handleModal={handleModal} open={open}  />
                    );
                }
                return subscriptionInformation;
            }}
        </Query>
    );
};

SubscriptionTnC.propTypes = {
    brand: shape({
        domain: string,
    }).isRequired,
    copy: string.isRequired,
    renderers: func.isRequired,
    userConfirmation: func.isRequired,
    handleModal: func.isRequired,
    open: bool.isRequired,
};

export default SubscriptionTnC;
